define(
	'SuiteDynamics.CategoryPageChanges.PLPLifestyleImage',
	[
		'underscore',
		'Facets.ItemCell.View'
	],
	function (
		_,
		FacetsItemCellView
	) {
		'use strict';

		FacetsItemCellView.prototype.events = _.extend(FacetsItemCellView.prototype.events || {}, {
			'mouseover [class^="facets-item-cell-"][class$="-image"]': 'handleMouseOver',
			'mouseleave [class^="facets-item-cell-"][class$="-image"]': 'handleMouseLeave'
		});

		FacetsItemCellView.prototype.handleMouseOver = function (e) {
			var $image = this.getImageElement();

			if (!$image) return;

			if (!this.originalImageSrc) {
				this.originalImageSrc = $image.attr('src');
			}

			var originalHeight = $image.height();

			var imageInfo = this.getImageInfo($image);

			if (imageInfo.isLifestyleImage) return;

			var lifestyleImage = this.findLifestyleImage(imageInfo.color);

			if (lifestyleImage) {
				$image.css('height', originalHeight + 'px');
				$image.attr('src', lifestyleImage);
			}
		};

		FacetsItemCellView.prototype.handleMouseLeave = function (e) {
			var $image = this.getImageElement();

			if (!$image || !this.originalImageSrc) return;

			$image.attr('src', this.originalImageSrc);
			this.originalImageSrc = null;

			$image.css('height', '');
		};

		FacetsItemCellView.prototype.getImageElement = function () {
			return this.$('[class^="facets-item-cell-"][class$="-image"] img');
		};

		FacetsItemCellView.prototype.getImageInfo = function ($image) {
			var imageSrc = decodeURIComponent($image.attr('src'));
			var regex = /\/(?:[A-Z0-9]+)_([A-Za-z\s]+)?_(\d+)/;
			var match = imageSrc.match(regex);

			var color = match ? match[1] : null;
			var isLifestyleImage = match && match[2] === '06';

			return {
				color: color,
				isLifestyleImage: isLifestyleImage
			};
		};

		FacetsItemCellView.prototype.findLifestyleImage = function (color) {
			var imageDetails = this.model.get('itemimages_detail') || {};

			var lifestyleImage = this.getLifestyleImageForColor(imageDetails, color);

			if (!lifestyleImage) {
				lifestyleImage = this.getFirstAvailableLifestyleImage(imageDetails);
			}

			return lifestyleImage;
		};

		FacetsItemCellView.prototype.getLifestyleImageForColor = function (imageDetails, color) {
			if (color && imageDetails[color] && imageDetails[color].urls) {
				for (var i = 0; i < imageDetails[color].urls.length; i++) {
					if (this.isLifestyleImage(imageDetails[color].urls[i].url)) {
						return imageDetails[color].urls[i].url;
					}
				}
			}
			return null;
		};

		FacetsItemCellView.prototype.getFirstAvailableLifestyleImage = function (imageDetails) {
			for (var color in imageDetails) {
				if (imageDetails.hasOwnProperty(color) && imageDetails[color].urls) {
					for (var i = 0; i < imageDetails[color].urls.length; i++) {
						if (this.isLifestyleImage(imageDetails[color].urls[i].url)) {
							return imageDetails[color].urls[i].url;
						}
					}
				}
			}
			return null;
		};

		FacetsItemCellView.prototype.isLifestyleImage = function (url) {
			return url.indexOf('_06.jpg') !== -1;
		};

		return {
			mountToApp: function (container) {
			}
		};
	}
);
